import { render, staticRenderFns } from "./createGuideBook.vue?vue&type=template&id=54edb8a0&"
import script from "./createGuideBook.vue?vue&type=script&lang=js&"
export * from "./createGuideBook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports